import "./contact.css";
import { AiOutlineYoutube } from "react-icons/ai";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";

function Contact() {
  return (
    <div id="contact" className="container contact-container">
      <h1>Contact Me</h1>
      <div className="contact-links">
        <a
          href="https://www.youtube.com/channel/UCIzyuVGhbLUizb6F7mTd1yA"
          className="contact youtube"
          target={"blank"}
        >
          <AiOutlineYoutube className="icon" />
          <h2>
            Youtube <span>Ugyel21</span>
          </h2>
        </a>

        <a
          href="https://wa.link/bywzv3"
          className="contact whatsapp"
          target={"blank"}
        >
          <AiOutlineWhatsApp className="icon" />
          <h2>
            Whatsapp <span>+975 17970072</span>
          </h2>
        </a>

        <a href="https://www.instagram.com/ugyel21/" className="contact instagram" target={"blank"}>
          <AiOutlineInstagram className="icon" />
          <h2>
            Instagram <span>Ugyel21</span>
          </h2>
        </a>
      </div>
    </div>
  );
}

export default Contact;
